import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CityService } from '../services/city.service';
import { ServicePrmium } from '../models/servicePremium';
import { AgendaProConst } from '../models/constantesAgendaPro';
import { TemplateEmail } from '../models/templateEmail';
import { NameValue } from '../models/nameValue';
import { MarkService } from '../services/mark.service';
import { ModelService } from '../services/model.service';
import { ConceptService } from '../services/concept.service';
import { Mark } from '../models/mark';
import { Model } from '../models/model';
import { Concept } from '../models/concept';
import { City } from '../models/agenda.model';
import { ServicePremiumService } from '../services/servicePremium.service';
import { TemplateEmailService } from '../services/templateEmail.service';
import { EmailService } from '../services/email.service';

@Component({
    selector: 'app-agendapro',
    templateUrl: './agendaproAlt.component.html',
    styleUrls: ['./agendaproAlt.component.css'],
    providers: [CityService, MarkService, ModelService, ConceptService, ServicePremiumService, TemplateEmailService, EmailService]
})
export class AgendaProComponent implements OnInit {
    public listMarks: Mark[];
    public listModels: Model[] = [];
    public agendaPro: ServicePrmium;
    public listConcepto: Concept[];
    public listCities: City[];
    public template: TemplateEmail;
    public variables: string[] = [];
    public variables1: NameValue;
    public listVariables: NameValue[] = [];
    public loading: boolean;
    public modeloValidate: boolean;
    public mark: number;
    public model: number;
    public concept: number;
    public city: number;
    public identification: string;
    public phone: string;
    constructor(
        private _router: Router,
        private _route: ActivatedRoute,
        private _cityService: CityService,
        private _markService: MarkService,
        private _modelService: ModelService,
        private _conceptService: ConceptService,
        private _servicePremiumService: ServicePremiumService,
        private _templateEmailService: TemplateEmailService,
        private _emailService: EmailService
    ) {
        this.agendaPro = new ServicePrmium();
        this.mark = 0;
        this.model = 0;
        this.concept = 0;
        this.city = 0;
        this.identification = '';
        this.phone = '';
        this.agendaPro.aceptShipping = false;
        this.agendaPro.aceptPolicy = false;
        this.variables1 = new NameValue();
        this.template = new TemplateEmail();
    }
    ngOnInit() {
        this.getMarca();
        this.getConcepto();
        this.getCity();
        this.getTemplateEmail();
    }
    getMarca() {
        this._markService.get().subscribe(
            response => {
                if (response.statusCode === '200 OK') {
                    this.listMarks = response.object;
                } else {
                    console.log(response);
                }
            },
            error => {
                console.log(<any>error);
            }
        );
    }
    changeMarca() {
        this.listModels = [];
        this.agendaPro.modelId = 0;
        this.getModelos(this.mark);
    }
    getModelos(marcaid) {
        this.modeloValidate = false;
        this._modelService.getByMarkId(marcaid, false).subscribe(
            response => {
                if (response.statusCode === '200 OK') {
                    this.listModels = response.object;
                    this.modeloValidate = true;
                } else {
                    console.log(response);
                }
            },
            error => {
                console.log(<any>error);
            }
        );
    }
    getConcepto() {
        this._conceptService.get().subscribe(
            response => {
                if (response.statusCode === '200 OK') {
                    this.listConcepto = response.object;
                } else {
                    console.log(response);
                }
            },
            error => {
                console.log(<any>error);
            }
        );
    }
    getCity() {
        this._cityService.getByDepartmentId(3, false).subscribe(
            response => {
                if (response.statusCode === '200 OK') {
                    this.listCities = response.object;
                } else {
                    console.log(response);
                }
            },
            error => {
                console.log(<any>error);
            }
        );
    }
    createAgendaPro() {
        this.loading = true;
        this.agendaPro.date = new Date();
        this.agendaPro.cityId = Number(this.city);
        this.agendaPro.conceptId = Number(this.concept);
        this.agendaPro.markId = Number(this.mark);
        this.agendaPro.modelId = Number(this.model);
        this.agendaPro.identification = String(this.identification);
        this.agendaPro.phone = String(this.phone);
        this.variables.forEach(vr => {
            if (vr.replace('{', '').replace('}', '').toUpperCase() === AgendaProConst.fecha) {
                this.variables1.name = 'fecha';
                this.variables1.value = this.agendaPro.date.toDateString();
                this.listVariables.push(this.variables1);
                this.variables1 = new NameValue();
            } else if (vr.replace('{', '').replace('}', '').toUpperCase() === AgendaProConst.direccion) {
                this.variables1.name = 'direccion';
                this.variables1.value = String(this.agendaPro.address);
                this.listVariables.push(this.variables1);
                this.variables1 = new NameValue();
            } else if (vr.replace('{', '').replace('}', '').toUpperCase() === AgendaProConst.correo) {
                this.variables1.name = 'correo';
                this.variables1.value = String(this.agendaPro.email);
                this.listVariables.push(this.variables1);
                this.variables1 = new NameValue();
            } else if (vr.replace('{', '').replace('}', '').toUpperCase() === AgendaProConst.identificacion) {
                this.variables1.name = 'identificacion';
                this.variables1.value = String(this.agendaPro.identification);
                this.listVariables.push(this.variables1);
                this.variables1 = new NameValue();
            } else if (vr.replace('{', '').replace('}', '').toUpperCase() === AgendaProConst.nombre) {
                this.variables1.name = 'nombre';
                this.variables1.value = String(this.agendaPro.name);
                this.listVariables.push(this.variables1);
                this.variables1 = new NameValue();
            } else if (vr.replace('{', '').replace('}', '').toUpperCase() === AgendaProConst.telefono) {
                this.variables1.name = 'telefono';
                this.variables1.value = String(this.agendaPro.phone);
                this.listVariables.push(this.variables1);
                this.variables1 = new NameValue();
            }
        });
        if (this.agendaPro.aceptPolicy == false || this.agendaPro.address == '' || this.agendaPro.name == ''
            || this.agendaPro.email == '' || this.agendaPro.phone == '' || this.agendaPro.identification == ''
            || this.agendaPro.markId == 0 || this.agendaPro.modelId == 0 || this.agendaPro.conceptId == 0 || this.agendaPro.cityId == 0) {
            this.loading = false;
            alert('Por favor diligencie todos los datos');
        } else {
            this._servicePremiumService.create(this.agendaPro).subscribe(
                response => {
                    if (response.statusCode === '200 OK') {
                        if (this.agendaPro.conceptId == 1 || this.agendaPro.conceptId == 2) {
                            this.sendEmail(this.listVariables, 1, this.agendaPro.email, this.agendaPro.name, this.agendaPro.aceptShipping);
                        } else {
                            this._router.navigate(['/garantia']);
                        }
                    } else {
                        console.log(response);
                    }
                },
                error => {
                    console.log(<any>error);
                }
            );
        }
    }
    getTemplateEmail() {
        this._templateEmailService.getById(1).subscribe(
            response => {
                if (response.statusCode === '200 OK') {
                    this.template = response.object;
                    this.variables = this.template.variable.split(',');
                } else {
                    console.log(response);
                }
            },
            error => {
                console.log(<any>error);
            }
        );
    }
    sendEmail(entity, templateId, emailaddress, name, aceptaEnvio) {
        this._emailService.create(entity, templateId, emailaddress, name, aceptaEnvio).subscribe(
            response => {
                if (response.statusCode === '200 OK') {
                    this._router.navigate(['/feedback']);
                } else {
                    console.log(response);
                }
            },
            error => {
                console.log(<any>error);
            }
        );
    }
}